<script lang="ts">
  import { enhance } from '$app/forms';
  import IconEyePlus from '~icons/tabler/eye-plus';
  import IconEyeMinus from '~icons/tabler/eye-minus';
  import Tooltip from '$lib/client/Tooltip.svelte';
  import Modal from '$lib/client/Modal.svelte';
  import Alert from '$lib/client/Alert.svelte';

  export let isSubscribed = false;
  export let keyword: string;

  let showModal = false;
  let loading = false;
  let error: string | null = null;

  function closeModal() {
    showModal = false;
    loading = false;
    error = null;
  }
</script>

{#if isSubscribed}
  <Tooltip>
    <button slot="trigger" style="font-size: 1.25em" on:click={() => (showModal = true)}>
      <IconEyeMinus />
    </button>
    <p class="fw-normal">Remove from watchlist</p>
  </Tooltip>
  <Modal bind:open={showModal}>
    <div slot="header">
      <h6 class="mb-0">Remove from watchlist</h6>
    </div>
    <div slot="body">
      {#if error}
        <Alert variant="danger">Error: {error}</Alert>
      {/if}
      <p class="mb-4">
        Remove keyword from watchlist? You won't receive updates for new listings for <strong>{keyword}</strong> keyword
        anymore.
      </p>
      <a class="d-block mb-4 fs-7" href="/backoffice/account/notifications/">Manage all watchlist entries</a>
      <form
        method="POST"
        action="?/removeFromWatchlist"
        use:enhance={({}) => {
          loading = true;

          return async ({ result }) => {
            if (result.type === 'success') {
              isSubscribed = false;
              closeModal();
            } else if (result.type === 'error') {
              error = result.error.message;
            }
          };
        }}
      >
        <input type="hidden" id="keyword" name="keyword" value={keyword} />
        <div class="hstack gap-3">
          <button type="submit" class="btn btn-danger" disabled={loading}>Remove from watchlist</button>
          <button type="button" class="btn btn-secondary" on:click={closeModal}>Cancel</button>
        </div>
      </form>
    </div>
  </Modal>
{:else}
  <Tooltip>
    <button slot="trigger" style="font-size: 1.25em" on:click={() => (showModal = true)}>
      <IconEyePlus />
    </button>
    <p class="fw-normal">Add keyword to watchlist</p>
  </Tooltip>
  <Modal bind:open={showModal}>
    <div slot="header">
      <h6 class="mb-0">Add to watchlist</h6>
    </div>
    <div slot="body">
      {#if error}
        <Alert variant="danger">Error: {error}</Alert>
      {/if}
      <p class="mb-4">
        Stay updated! Get alerts for new listings that match <strong>{keyword}</strong> keyword.
      </p>
      <a class="d-block mb-4 fs-7" href="/backoffice/account/notifications/">Manage all watchlist entries</a>
      <form
        method="POST"
        action="?/addToWatchlist"
        use:enhance={({}) => {
          loading = true;

          return async ({ result }) => {
            if (result.type === 'success') {
              isSubscribed = true;
              closeModal();
            } else if (result.type === 'error') {
              error = result.error.message;
            }
          };
        }}
      >
        <input type="hidden" id="keyword" name="keyword" value={keyword} />
        <div class="hstack gap-3">
          <button type="submit" class="btn btn-success" disabled={loading}>Add to watchlist</button>
          <button type="button" class="btn btn-secondary" on:click={closeModal}>Cancel</button>
        </div>
      </form>
    </div>
  </Modal>
{/if}
